// extracted by mini-css-extract-plugin
module.exports = {"header":"DataList_header__nC6ox"};